// extracted by mini-css-extract-plugin
export default {"menuIcon":"TerritoryMenu_menuIcon__A0RDZ"};